module.exports = __webpack_public_path__ + "static/media/41.804e2fd3.mp3";